import { clamp } from 'es-toolkit';
import { LngLat, LngLatBounds } from 'maplibre-gl';
import type { RawCoordinates } from '../map-types';
import { extendBounds } from './extend-bounds';

export const fitBoundsToPoint = (
  point: RawCoordinates,
  center: RawCoordinates
) => {
  const seAndNW = new LngLatBounds(center, center);
  const extension = new LngLat(
    Math.abs(center.lng - point.lng),
    clamp(Math.abs(center.lat - point.lat), -90, 90)
  );

  return extendBounds(seAndNW, extension);
};
